import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Spinner, Badge } from "reactstrap";

interface CompleteVisitModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  visitNumber: string;
  subjects: any[];
  isPending?: boolean;
}

const CompleteVisitModal: React.FC<CompleteVisitModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  visitNumber,
  subjects = [],
  isPending = false
}) => {

  const hasPending = subjects[0]?.subjectsinvisitcount ;
  const droppedpending = subjects[0]?.totaldropoutcount ;
  const blockedpending = subjects[0]?.totalblockcount;
  
  return (
    <Modal isOpen={isOpen} toggle={onClose} centered size="lg" className="common_modal">
      <ModalHeader toggle={onClose} className="bg-light border-bottom p-3">
        <div className="d-flex align-items-center gap-2">
          <div style={{
            width: 36, height: 36, borderRadius: 10, background: "#ecfdf5",
            display: "flex", alignItems: "center", justifyContent: "center", border: "1px solid #a7f3d0"
          }}>
            <i className="ri-checkbox-circle-line text-success fs-18" />
          </div>
          <div>
            <h5 className="modal-title mb-0 fw-bold">Complete Visit Session</h5>
            <span className="text-muted" style={{ fontSize: 12 }}>
              {visitNumber}
            </span>
          </div>
        </div>
      </ModalHeader>
      <ModalBody className="p-4" style={{ background: "#fcfcfd" }}>
        
        {/* Requirements Card */}
        <div style={{
          border: "1px solid #e2e8f0",
          borderRadius: 12,
          padding: 20,
          background: "#ffffff",
          boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.05)",
          marginBottom: 20
        }}>
          {/* Header */}
          <div className="d-flex align-items-center gap-2 mb-3">
            <div style={{
              width: 32, height: 32, borderRadius: 8, background: "#f5f3ff",
              display: "flex", alignItems: "center", justifyContent: "center"
            }}>
              <i className="ri-list-check-2 fs-16" style={{ color: "#8b5cf6" }} />
            </div>
            <span className="fw-bold text-dark" style={{ fontSize: 15 }}>Requirements to Complete</span>
          </div>

          {/* Checklist items wrapper */}
          <div style={{
            border: "1px solid #e2e8f0",
            borderRadius: 8,
            overflow: "hidden"
          }}>
            {/* Item 1: Checked Out Subjects */}
            <div className="d-flex align-items-center justify-content-between p-3 border-bottom" style={{ background: "#ffffff", borderColor: "#e2e8f0" }}>
              <div className="d-flex align-items-center gap-2">
                {hasPending ? (
                  <div style={{
                    width: 24, height: 24, borderRadius: "50%",
                    background: "#fef2f2", display: "flex",
                    alignItems: "center", justifyContent: "center"
                  }}>
                    <i className="ri-close-line text-danger fs-14" style={{ fontWeight: 800 }} />
                  </div>
                ) : (
                  <div style={{
                    width: 24, height: 24, borderRadius: "50%",
                    background: "#ecfdf5", display: "flex",
                    alignItems: "center", justifyContent: "center"
                  }}>
                    <i className="ri-check-line text-success fs-14" style={{ fontWeight: 800 }} />
                  </div>
                )}
                <span className="text-dark" style={{ fontSize: 13.5, fontWeight: 500 }}>
                  All assigned subjects must be checked out {hasPending && <span className="text-muted fw-normal">({hasPending} remaining)</span>}
                </span>
              </div>
              <Badge 
                color={hasPending ? "danger" : "success"}
                className={hasPending ? "bg-danger-subtle text-danger border border-danger-subtle px-3 py-1" : "bg-success-subtle text-success border border-success-subtle px-3 py-1"}
                style={{ fontSize: 12, borderRadius: 20, fontWeight: 600 }}
              >
                {hasPending ? "Pending" : "Completed"}
              </Badge>
            </div>
            {/* Item 2: pending verification for dropped subjects */}
            <div className="d-flex align-items-center justify-content-between p-3 border-bottom" style={{ background: "#ffffff", borderColor: "#e2e8f0" }}>
              <div className="d-flex align-items-center gap-2">
                {droppedpending ? (
                  <div style={{
                    width: 24, height: 24, borderRadius: "50%",
                    background: "#fef2f2", display: "flex",
                    alignItems: "center", justifyContent: "center"
                  }}>
                    <i className="ri-close-line text-danger fs-14" style={{ fontWeight: 800 }} />
                  </div>
                ) : (
                  <div style={{
                    width: 24, height: 24, borderRadius: "50%",
                    background: "#ecfdf5", display: "flex",
                    alignItems: "center", justifyContent: "center"
                  }}>
                    <i className="ri-check-line text-success fs-14" style={{ fontWeight: 800 }} />
                  </div>
                )}
                <span className="text-dark" style={{ fontSize: 13.5, fontWeight: 500 }}>
                  All dropped subjects must be verified {droppedpending && <span className="text-muted fw-normal">({droppedpending} remaining)</span>}
                </span>
              </div>
              <Badge 
                color={droppedpending ? "danger" : "success"}
                className={droppedpending ? "bg-danger-subtle text-danger border border-danger-subtle px-3 py-1" : "bg-success-subtle text-success border border-success-subtle px-3 py-1"}
                style={{ fontSize: 12, borderRadius: 20, fontWeight: 600 }}
              >
                {droppedpending ? "Pending" : "Completed"}
              </Badge>
              
            </div>
            {/* Item 3: blocked subjects count */}
            <div className="d-flex align-items-center justify-content-between p-3 border-bottom" style={{ background: "#ffffff", borderColor: "#e2e8f0" }}>
              <div className="d-flex align-items-center gap-2">
                {blockedpending ? (
                  <div style={{
                    width: 24, height: 24, borderRadius: "50%",
                    background: "#fef2f2", display: "flex",
                    alignItems: "center", justifyContent: "center"
                  }}>
                    <i className="ri-close-line text-danger fs-14" style={{ fontWeight: 800 }} />
                  </div>
                ) : (
                  <div style={{
                    width: 24, height: 24, borderRadius: "50%",
                    background: "#ecfdf5", display: "flex",
                    alignItems: "center", justifyContent: "center"
                  }}>
                    <i className="ri-check-line text-success fs-14" style={{ fontWeight: 800 }} />
                  </div>
                )}
                <span className="text-dark" style={{ fontSize: 13.5, fontWeight: 500 }}>
                  All blocked subjects must be verified {blockedpending && <span className="text-muted fw-normal">({blockedpending} remaining)</span>}
                </span>
              </div>
              <Badge 
                color={blockedpending ? "danger" : "success"}
                className={blockedpending ? "bg-danger-subtle text-danger border border-danger-subtle px-3 py-1" : "bg-success-subtle text-success border border-success-subtle px-3 py-1"}
                style={{ fontSize: 12, borderRadius: 20, fontWeight: 600 }}
              >
                {blockedpending ? "Pending" : "Completed"}
              </Badge>
              
            </div>
          </div>
        </div>

        {/* Info Banner */}
        <div className="d-flex align-items-center gap-2 p-3" style={{
          background: "#eff6ff",
          border: "1px solid #bfdbfe",
          borderRadius: 8,
          color: "#1e3a8a",
          fontSize: 13
        }}>
          <div style={{
            width: 24, height: 24, borderRadius: "50%",
            background: "#dbeafe", display: "flex",
            alignItems: "center", justifyContent: "center",
            flexShrink: 0
          }}>
            <i className="ri-information-line text-primary fs-14" style={{ fontWeight: 800 }} />
          </div>
          <span>This visit cannot be completed until all required subject actions are finished. Please review the Visit Details page to resolve any pending check-outs and verifications.</span>
        </div>

      </ModalBody>
      <ModalFooter className="bg-white border-top p-3">
        <Button outline color="dark" onClick={onClose} disabled={isPending} >
          Cancel
        </Button>
        <Button 
          color="primary" 
          onClick={onConfirm} 
          disabled={hasPending || isPending || droppedpending || blockedpending} 
          outline
        >
          {isPending && <Spinner size="sm" className="me-2" />}
          <i className="ri-checkbox-circle-line me-1" /> Complete Visit
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default CompleteVisitModal;
